module.exports = __webpack_public_path__ + "img/5g.064dc686.svg";